import { render, staticRenderFns } from "./PassportConfig.vue?vue&type=template&id=461977e9&scoped=true"
import script from "./PassportConfig.vue?vue&type=script&lang=js"
export * from "./PassportConfig.vue?vue&type=script&lang=js"
import style0 from "./PassportConfig.vue?vue&type=style&index=0&id=461977e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461977e9",
  null
  
)

export default component.exports